<script setup>
import { computed } from "vue";
import STATUS_TONE_MAP from "@/Constans/StatusToneMap";

const props = defineProps({
  percentage: {
    type: Number,
    required: true,
  },
  type: {
    type: String,
    default: "en_curso",
  },
});

const resolvedTone = computed(
  () => STATUS_TONE_MAP[props.type] || STATUS_TONE_MAP.en_curso
);

const barStyle = computed(() => ({
  width: `${Math.max(0, Math.min(100, props.percentage))}%`,
  backgroundColor: resolvedTone.value.border,
}));
</script>

<template>
  <div class="progress">
    <div class="progress-bar" :style="barStyle"></div>
  </div>
</template>
